(() => {
  const hasExplicitVariant = () => new URLSearchParams(window.location.search).has('variant');

  const selectFirstAvailable = (picker) => {
    if (!picker || hasExplicitVariant() || picker.dataset.raFirstAvailableApplied === 'true') return false;

    const json = picker.querySelector('script[type="application/json"]:not(#foxify-selected-variant)');
    if (!json) return false;

    let variants;
    try {
      variants = JSON.parse(json.textContent.trim());
    } catch {
      return false;
    }

    if (!Array.isArray(variants) || !variants.length) return false;

    const renderedId = Number(picker.dataset.currentVariantId);
    const renderedVariant = variants.find((variant) => Number(variant.id) === renderedId);
    if (!renderedVariant || renderedVariant.available) {
      picker.dataset.raFirstAvailableApplied = 'true';
      return true;
    }

    const firstAvailable = variants.find((variant) => variant.available);
    if (!firstAvailable) {
      picker.dataset.raFirstAvailableApplied = 'true';
      return true;
    }

    const fields = Array.from(picker.querySelectorAll('.x-variant-picker__input'));
    firstAvailable.options.forEach((value, index) => {
      const field = fields[index];
      if (!field) return;

      const select = field.querySelector('select');
      if (select) {
        select.value = value;
        const selected = Array.from(select.options).find((option) => option.value === value);
        if (selected) {
          Array.from(select.options).forEach((option) => option.removeAttribute('selected'));
          selected.setAttribute('selected', 'selected');
        }
        return;
      }

      const radio = Array.from(field.querySelectorAll('input[type="radio"]')).find((input) => input.value === value);
      if (radio) radio.checked = true;
    });

    picker.dataset.raFirstAvailableApplied = 'true';

    const lastField = fields[fields.length - 1];
    const target = lastField?.querySelector('select') || lastField?.querySelector('input[type="radio"]:checked');
    if (target) {
      target.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    return false;
  };

  const run = () => {
    document.querySelectorAll('x-variant-picker').forEach(selectFirstAvailable);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();